(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/statistics/assets/javascripts/models/odds.js') >= 0) return;  svs.modules.push('/components/statistics/statistics/assets/javascripts/models/odds.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  var OddsModel = _.extend({}, svs.statistics.mixins.SocketSubscriber, {
    url: function() {
      return svs.core.jupiter.url() + (this.socketResourcePath || '');
    },

    initialize: function(options) {
      options = options || {};

      this.logger = new svs.core.log.Logger('svs.statistics.models.Odds');
      this.socketResourcePath =
        '/sport/1/matches/' + this.get('matchId') + '/odds';

      if (options.subscribe) {
        this.startPush();
      }

      if (options.fetch) {
        this.fetch();
      }
    },

    parse: function(response) {
      if (_.isObject(response.oddsInfo)) {
        return response.oddsInfo;
      }

      return false;
    },

    onSocketUpdate: function(param) {
      if (!_.isObject(param) && param.length === 0) {
        param = {};
      }
      param.matchId = this.get('matchId');

      if (svs.statistics && svs.statistics.socketCache) {
        svs.statistics.socketCache.add('MATCH_ODDS', param);
      }

      if (param.oddsInfo) {
        this.set(this.parse(param));
      }
    },

    startPush: function() {
      this.subscribe(this.socketResourcePath, this.onSocketUpdate, true);
    },

    stopPush: function() {
      this.unsubscribe();
    },

    getOdds: function() {
      if (this.getLiveOdds() && this.get('showLiveOdds')) {
        return this.getLiveOdds();
      } else if (_.isObject(this.get('odds'))) {
        return this.get('odds');
      }

      return false;
    },

    getLiveOdds: function() {
      if (_.isObject(this.get('liveOdds'))) {
        return this.get('liveOdds');
      }

      return false;
    },

    getFavourite: function() {
      if (_.isObject(this.get('favourite'))) {
        return this.get('favourite');
      }

      return false;
    }
  });

  svs.statistics.models.Odds = Backbone.Model.extend(OddsModel);
})(Backbone, _, svs);

 })(window);